import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";

const SitemapPage = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="sitemap-page-container">
      <div className="museum-wrap">
        {/* Header Section */}
        <div className="sitemap-header-section" data-aos="fade-up">
          <span className="section-label">Site Navigation</span>
          <h1 className="sitemap-heading">
            Sitemap
          </h1>
          <p className="section-text">
            A complete overview of all pages and content available on the Morphis website.
            Use this guide to navigate through our services, company information, and resources.
          </p>
        </div>

      {/* All Categories in one row */}
<div className="sitemap-categories-row">
         <div className="sitemap-category" data-aos="fade-up" data-aos-delay="100">
            <h3 className="category-title">Main</h3>
            <ul className="sitemap-list">
              <li><Link to="/" className="sitemap-link">Home</Link></li>
              <li><Link to="/about" className="sitemap-link">About Us</Link></li>
              <li><Link to="/philosophy" className="sitemap-link">Philosophy</Link></li>
              <li><Link to="/services" className="sitemap-link">Our Services</Link></li>
              <li><Link to="/team" className="sitemap-link">Team</Link></li>
              <li><Link to="/contact" className="sitemap-link">Contact Us</Link></li>
            </ul>
          </div>

          {/* <div className="sitemap-category">
            <h3 className="category-title">Resources</h3>
            <ul className="sitemap-list">
              <li><Link to="/careers" className="sitemap-link">Careers</Link></li>
              <li><Link to="/blogs" className="sitemap-link">Blogs</Link></li>
            </ul>
          </div>*/}

          {/*<div className="sitemap-category" data-aos="fade-up" data-aos-delay="200">
            <h3 className="category-title">Services</h3>
            <ul className="sitemap-list">
              <li><Link to="/services/first-100-days" className="sitemap-link">First 100-180 Days</Link></li>
              <li><Link to="/services/ipo-leadership" className="sitemap-link">IPO Leadership</Link></li>
              <li><Link to="/services/portfolio-management" className="sitemap-link">Portfolio Management</Link></li>
              <li><Link to="/services/navigating-exits" className="sitemap-link">Navigating Exits</Link></li>
              <li><Link to="/services/mis-fpa" className="sitemap-link">MIS and FP&A</Link></li>
              <li><Link to="/services/valuation-expertise" className="sitemap-link">Valuation Expertise</Link></li>
              <li><Link to="/services/non-pe-engagements" className="sitemap-link">Non-PE Engagements</Link></li>
            </ul>
          </div>*/}

          <div className="sitemap-category" data-aos="fade-up" data-aos-delay="300">
            <h3 className="category-title">Legal</h3>
            <ul className="sitemap-list">
              <li><Link to="/privacy-policy" className="sitemap-link">Privacy Policy</Link></li>
              <li><Link to="/sitemap" className="sitemap-link">Sitemap</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <style>{`
        /*
          Height budget (desktop ≥1008px):
            navbar  = 68px
            footer  = 50px
            total   = 118px   (no breadcrumb on sitemap)

          Strategy: container fills height, scrolls as one unit if needed.
          padding-top gives breathing room below navbar so eyebrow is visible.
        */
        .sitemap-page-container {
          height: calc(100vh - 118px);
          overflow-y: auto;
          overflow-x: hidden;
          display: flex;
          flex-direction: column;
          background: var(--bg-main, #fffdf6);
        }

        .sitemap-page-container > .museum-wrap {
          padding-top: 48px;
          padding-bottom: 40px;
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        /* Header section — fixed size, never shrinks */
        .sitemap-header-section {
          flex-shrink: 0;
          margin-bottom: 36px;
        }

        .sitemap-heading {
          font-family: var(--font-heading);
          font-size: clamp(2rem, 5vw, 3.6rem);
          line-height: 1.1;
          margin-bottom: 0.9rem;
          color: var(--color-dark, #1a1a1a);
          font-weight: 400;
        }

        .section-text {
          font-family: var(--font-body);
          font-size: var(--fs-para, 1.05rem);
          color: var(--text-sub, #2d2d2d);
          line-height: 1.65;
          max-width: 800px;
          margin-bottom: 0;
        }

        /* Categories row — fills remaining space */
        .sitemap-categories-row {
          display: flex;
          flex-wrap: wrap;
          gap: clamp(40px, 5vw, 60px);
          flex: 1;
        }

        .sitemap-category {
          flex: 1;
          min-width: 180px;
        }

        .category-title {
          font-family: var(--font-heading);
          font-size: 1.2rem;
          font-weight: 400;
          color: var(--color-dark, #1a1a1a);
          margin-bottom: 1rem;
          padding-bottom: 0.5rem;
          border-bottom: 1px solid var(--border-light, #e6e0d4);
        }

        .sitemap-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .sitemap-list li {
          margin-bottom: 0.75rem;
        }

        .sitemap-link {
          font-family: var(--font-body);
          font-size: var(--fs-para, 1rem);
          color: var(--text-sub, #2d2d2d);
          text-decoration: none;
          transition: all 0.2s ease;
          display: inline-block;
        }

        .sitemap-link:hover {
          color: var(--color-orange, #E87722);
          transform: translateX(4px);
        }

        /* High-DPI 150%: nav=64, footer=52 → 116px */
        @media screen and (min-resolution: 144dpi) and (min-width: 1008px) {
          .sitemap-page-container {
            height: calc(100vh - 116px);
          }
        }

        /* Tablet & mobile — natural scroll */
        @media (max-width: 1007px) {
          .sitemap-page-container {
            height: auto;
            overflow: visible;
          }

          .sitemap-page-container > .museum-wrap {
            padding-top: 60px;
            padding-bottom: 60px;
          }

          .sitemap-categories-row {
            flex-direction: column;
            gap: 32px;
          }

          .sitemap-category {
            min-width: 100%;
          }
        }

        @media (max-width: 480px) {
          .sitemap-page-container > .museum-wrap {
            padding-top: 44px;
            padding-bottom: 48px;
          }

          .sitemap-heading {
            font-size: 1.8rem !important;
          }

          .section-text,
          .sitemap-link {
            font-size: 0.9rem;
          }

          .category-title {
            font-size: 1.1rem;
          }

          .sitemap-header-section {
            margin-bottom: 24px;
          }
        }
      `}</style>
    </div>
  );
};

export default SitemapPage;